export default __webpack_public_path__ + "static/DevelopmentWithoutDisplacement-a1dffb1ce83bc033f3a832bf05899b6c.jpg";